module.exports = __webpack_public_path__ + "pic/18.e6582e43.png";